var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-message-history"},[(_vm.items.length)?_vm._l((_vm.items),function(message,messageIdx){return _c('f-message',{key:messageIdx,attrs:{"message":message}})}):[_c('div',{staticClass:"text-medium mt-4 text-center"},[_vm._v(_vm._s(_vm.$t('message.noMessage')))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }